export default {
  source_title: 'Veri Kaynağı: Türkiye İstatistik Kurumu (TÜİK)',
  source_description:
    'Estimator24, <a href="https://www.tuik.gov.tr/" target="_blank" rel="noopener noreferrer">Türkiye İstatistik Kurumu (TÜİK)</a> tarafından sağlanan resmi istatistik verilerini kullanır. Bu veriler; verilen inşaat ruhsatı sayıları, gayrimenkul satış hacimleri ve Türkiye’nin ilçelerine göre inşaat dinamikleri bilgilerini içerir.',

  legal_title: 'Yasal Bildirim',
  legal_text:
    'Yayınlanan araştırmalar; yöntem, örneklem, dönem ve veri toplama yöntemi belirtilerek sunulmalıdır. TÜİK, sağlanan verileri inceleme ve netleştirme hakkına sahiptir. TÜİK bilgileri, resmi olarak yayınlanmadan önce dağıtılamaz. Tekrar kullanım yalnızca www.tuik.gov.tr kaynağı belirtilerek mümkündür. TÜİK, verilerin kullanılması veya bunlara erişilememesi durumunda doğabilecek sonuçlardan sorumlu tutulamaz.',

  disclaimer_title: 'Sorumluluk Reddi',
  disclaimer_text:
    'Estimator24, TÜİK’in resmi bir ortağı değildir ve kullanılan bilgilerin doğruluğu, eksiksizliği veya güncelliği konusunda hukuki sorumluluk kabul etmez. Veriler yalnızca analiz ve bilgilendirme amaçlı kullanılmaktadır.'
}
